import React, { Component } from 'react'
import { observer } from 'mobx-react'

import PresentationsBuilding from './PresentationsBuilding'
import PowerpointBuilder from './PowerpointBuilder'
import PresentationsStore from './PresentationsStore'

import './presentations.scss'

@observer
class PresentationTemplate extends Component {
    constructor(props) {
        super(props)
        this.presentationsStore = new PresentationsStore(props.store)
        this.presentationsStore.isTemplate = true
        this.loadStarted = false
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeydown)
        if (!this.loadStarted) {
            this.loadStarted = true
            this.kickoffLoad()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeydown)
    }

    kickoffLoad = () => {
        this.presentationsStore.clearBuildingError()
        const { match, location, history } = this.props
        const id = match?.params?.id
        const surveyId = location?.state?.surveyId

        if (!surveyId) {
            if (history) history.push('/presentation-templates')
            return
        }

        const surveysReady = this.presentationsStore.getAllSurveys()
        const templateReady = id
            ? this.presentationsStore.fetchTemplateById(id)
            : Promise.resolve(null)

        Promise.all([surveysReady, templateReady])
            .then(([, template]) => {
                if (!template) {
                    this.presentationsStore.setBuildingError(
                        'We couldn\'t find this template.',
                    )
                    return
                }
                try {
                    const data = typeof template.data === 'string'
                        ? JSON.parse(template.data)
                        : template.data
                    this.presentationsStore.templateId = template.id ?? id
                    this.presentationsStore.templateName = template.title ?? template.name ?? ''
                    this.presentationsStore.templateSurveyType = template.surveyType ?? null
                    this.presentationsStore.templateRespondentType = template.respondentType ?? null
                    this.presentationsStore.templateProductType = template.productType ?? null
                    this.presentationsStore.openTemplate({ data: data || null, startingSurveyId: surveyId })
                } catch (e) {
                    console.error('Failed to parse template data', e)
                    this.presentationsStore.setBuildingError(
                        'This template\'s saved data is corrupted and can\'t be opened.',
                    )
                }
            })
            .catch((e) => {
                console.error('Failed to load template', e)
                this.presentationsStore.setBuildingError(
                    e?.message || 'We couldn\'t load this template.',
                )
            })
    }

    handleRetry = () => {
        this.kickoffLoad()
    }

    handleBack = () => {
        const { history } = this.props
        if (history) history.push('/presentation-templates')
    }

    handleKeydown = (e) => {
        if (this.presentationsStore.stage !== 'builder') return

        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
            e.preventDefault()
        }

        switch (e.key) {
            case 'ArrowUp':
                this.presentationsStore.handleKeyboardListener(-1)
                break
            case 'ArrowDown':
                this.presentationsStore.handleKeyboardListener(1)
                break
            default:
                break
        }
    }

    render() {
        const store = this.presentationsStore

        if (store.stage === 'builder') {
            return <PowerpointBuilder store={store} />
        }

        return (
            <PresentationsBuilding
                store={store}
                onRetry={this.handleRetry}
                onBack={this.handleBack}
            />
        )
    }
}

export default PresentationTemplate
